'use strict';

import { CONST } from 'app_vodafone_ziggo/util/util';
import VZTcBaseCard from './VZTcBaseCard';

/**
 * @class VZTcWorryFree
 * @extends VZTcBaseCard
 * @description Handles the Teams Calling worry-free bundles card
 */
export default class VZTcWorryFree extends VZTcBaseCard {
    /**
     * @function connectedCallback
     * @description Sets up the card and event listeners
     */
    connectedCallback() {
        super.initializeCard();

        this.boundChange = this.boundChange.bind(this);
        document.addEventListener('vzbundleselectorslider:update', this.boundChange);
    }

    /**
     * @function disconnectedCallback
     * @description Removes event listeners when element is removed from the DOM
     */
    disconnectedCallback() {
        document.removeEventListener('vzbundleselectorslider:update', this.boundChange);
    }

    /**
     * @function boundChange
     * @description Handles quantity changes, updates configuration and enables/disables the next card
     * @param {CustomEvent} evt - The event from updating the range slider
     */
    boundChange(evt) {
        const selected = evt.detail.selected;
        const isHidden = this.closest('.js-question-content-block').classList.contains(CONST.classes.dNone);

        // Is the content visible to trigger a change?
        if (isHidden) return;

        // Emit configuration update event
        const questionId = this.getAttribute('data-question-id');
        const productId = selected.getAttribute('data-product-id');

        // Is the trigger coming from the correct content?
        if (evt.detail.identifier && evt.detail.identifier === questionId) {
            this.config = JSON.parse(document.querySelector('.js-active-configuration').value) || {};

            // There is no answer to update yet
            if (!this.config[questionId]) return;

            // Did the value change from what was previously selected?
            if ((this.config[questionId].pid && this.config[questionId].pid === productId) || !productId.includes('worry-free')) return;

            this.updateConfig('range', questionId, { pid: productId, qty: this.productCard.dataset.linesqty });
        }
    }
}

if (!window.customElements.get('vz-tc-worry-free')) {
    window.customElements.define('vz-tc-worry-free', VZTcWorryFree);
}
